module.exports = __webpack_public_path__ + "media/components/country-flag/static/af-337e43791af23a155243fcee3b16a734.svg";